﻿package com.milta.core.localization.translations.ro

import com.milta.core.localization.ProfileStrings

internal val Profile = ProfileStrings(
    screenTitle = "Profilul meu",
    sectionPersonal = "Informații personale",
    labelFirstName = "Prenume",
    labelLastName = "Nume",
    labelRole = "Rol",
    sectionLanguage = "Limbă",
    labelLanguage = "Limba aplicației",
    changeLanguageButton = "Schimbați limba",
    languageDialogTitle = "Alegeți limba",
    languageDialogConfirm = "Confirmați",
    languageDialogCancel = "Anulați",
    sectionPassword = "Securitate",
    labelCurrentPassword = "Parola actuală",
    labelNewPassword = "Parolă nouă",
    changePasswordButton = "Schimbați parola",
    successLanguageUpdated = "Limbă actualizată cu succes",
    successPasswordChanged = "Parolă schimbată cu succes",
    errorProfileNotFound = "Profilul nu a fost găsit",
    errorCurrentPasswordRequired = "Introduceți parola actuală",
    errorCurrentPasswordTooLong = "Parola actuală nu poate depăși 128 de caractere",
    errorNewPasswordRequired = "Introduceți o parolă nouă",
    errorNewPasswordTooShort = "Parola nouă trebuie să aibă cel puțin 8 caractere",
    errorNewPasswordTooLong = "Parola nouă nu poate depăși 128 de caractere",
    errorLanguageRequired = "Selectați o limbă",
    errorForbidden = "Nu sunteți autorizat să efectuați această acțiune",
    errorValidation = "Datele furnizate sunt invalide",
    errorGeneric = "A apărut o eroare. Încercați din nou.",
    signOut = "Deconectare",
    deleteAccount = "Ștergere cont",
    menuLanguage = "Limba interfeței",
    menuPassword = "Schimbare parolă",
    menuSubscription = "Abonamentul meu",
    menuPrivacy = "Confidențialitate & GDPR",
    linkedCodeLabel = "Cod de legătură unic",
    copyCode = "Copiați",
    codeCopied = "Copiat!",
    modeOrganisation = "Companie",
    modeDriver = "Șofer",
    roleDriver = "Șofer",
    roleOrganisation = "Companie",
    modeSwitchTitle = "Schimbați modul",
    modeSwitchHint = "Comutați între Modul Companie și Modul Șofer în orice moment",
    switchToEnterprise = "Mod Companie",
    switchToDriver = "Mod Șofer",
    menuPhone = "Număr de telefon",
    phoneOtpStepTitle = "Cod de verificare trimis prin SMS",
    successPhoneUpdated = "Numărul de telefon a fost actualizat",
    deleteAccountDialogTitle = "Ștergeți contul dvs.?",
    deleteAccountDialogMessage = "Această acțiune este ireversibilă. Informațiile dvs. personale vor fi șterse. Un cod de verificare va fi trimis prin SMS pentru confirmare.",
    deleteAccountDialogConfirm = "Continuați",
    deleteAccountOtpStepTitle = "Cod de verificare trimis prin SMS",
    deleteAccountConfirmButton = "Ștergeți definitiv",
    errorLastEnterpriseOwner = "Sunteți singurul administrator al companiei dvs. Adăugați un alt cont de Companie înainte de a-l șterge pe al dvs.",
    logoutPendingWarningTitle = "Livrări netrimise",
    logoutPendingWarningMessageSuffix = "livrare/livrări în așteptare vor fi pierdute dacă te deconectezi acum.",
    logoutPendingWarningConfirm = "Deconectează-te oricum",
    logoutPendingWarningCancel = "Anulează",
    modeSwitchActiveRouteWarningTitle = "Cursă în desfășurare",
    modeSwitchActiveRouteWarningMessage = "O cursă este în prezent în desfășurare. Schimbarea modului te va îndepărta de urmărirea acesteia. Continui?",
    modeSwitchActiveRouteWarningConfirm = "Schimbă oricum",
    modeSwitchActiveRouteWarningCancel = "Anulează",
)

